<template>
  <v-layout class="component-questionnaires-panel">
    <v-container fluid>
      <!--
        Questionnaires Panel
      -->
      <AdBreadcrumbs :items="breadcrumbs" />
      <v-row class="d-flex flex-row flex-md-nowrap">
         <v-col
          class="flex-grow-0 col-treeview"
          cols="12"
          md="auto"
        >
          <QuestionnaireTreeViewCard
            :trees="trees"
            :filters="filters"
          />
        </v-col>
        <v-col cols="12" md="auto" class="flex-grow-1 flex-shrink-1">
            <router-view :key="$route.fullPath"/>
        </v-col>
      </v-row>
    </v-container>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex'
import QuestionnaireTreeViewCard from '@/components/Rule/QuestionnaireTreeViewCard'

export default {
  name: 'QuestionnairesPanel',
  components: {
    QuestionnaireTreeViewCard
  },
  data () {
    return {
      filters: []
    }
  },
  computed: {
    ...mapGetters('questionnaire', ['isLoading', 'isLoaded', 'questionnaires', 'questionnaireActive', 'questionnairesAreEditable']),
    ...mapGetters('server', ['getItemStatuses']),

    breadcrumbs () {
      const breadcrumbs = [
        {
          text: this.$filters.getMatchingTranslation({ value: this.projectInFocus?.name }),
          to: { name: 'project-overview' },
          show: ['questionnaires', 'questionnaires-details-id', 'questionnaires-details-id-effectiveDate']
        },
        {
          text: this.$t('rules'),
          disabled: true,
          show: ['questionnaires', 'questionnaires-details-id', 'questionnaires-details-id-effectiveDate']

        },
        {
          exact: true,
          text: this.$t('questionnaires'),
          to: { name: 'questionnaires' },
          show: ['questionnaires', 'questionnaires-details-id', 'questionnaires-details-id-effectiveDate']
        },
        {
          text: this.$filters.getMatchingTranslation({
            value: this.questionnaireActive?.name
          }) || this.$route.params?.id,
          to: {
            name: 'questionnaires-details-id',
            params: {
              id: this.$route.params?.id
            }
          },
          show: ['questionnaires-details-id', 'questionnaires-details-id-effectiveDate']

        },
        {
          text: this.$route.params?.effectiveDate ? this.$filters.formatDateShort(this.$route.params?.effectiveDate) : '',
          to: {
            name: 'questionnaires-details-id-effectiveDate',
            params: {
              id: this.$route.params?.id,
              effectiveDate: this.$route.params?.effectiveDate
            }
          },
          show: ['questionnaires-details-id-effectiveDate']
        }
      ]
      return breadcrumbs.filter((breadcrumb) => breadcrumb.show.includes(this.$route.name))
    },
    trees () {
      return {
        questionnaireList: {
          artefact: 'QQ',
          name: this.$t('questionnaires'),
          icon: 'mdi-account-question',
          loading: this.isLoading('questionnaires'),
          loaded: this.isLoaded('questionnaires'),
          menu: this.questionnairesAreEditable,
          editable: false,
          expandable: true,
          items: this.questionnaires || [],
          key: 'uuid',
          text: (item, returnObject) => this.$filters.getMatchingTranslation({
            value: (item?.name || []).map((name) => ({
              ...name,
              '#text': item?.versionLabel
                ? `${name?.['#text']} (${item?.versionLabel})`
                : name?.['#text']
            })),
            selector: '#text',
            returnObject
          }),
          children: 'questionnaireresponse',
          onSelect: (activeItem) => {
            this.$store.commit('questionnaire/setQuestionnaireActive', activeItem)

            if (this.$store.getters['questionnaire/preserveQuestionnaireItemOnSelect']) {
              this.$store.commit('questionnaire/setQuestionnaireItem', null)
            }

            const routeName = 'questionnaires-details-id' + (activeItem.effectiveDate ? '-effectiveDate' : '')
            this.$router.push({ name: routeName, params: { id: activeItem.id || activeItem.ref, effectiveDate: activeItem.effectiveDate } }).catch(() => {})
          },
          onInsert: ({ type, mode, item, target }) => {
          },
          onBeforeEdit: () => {
            // Do nothing.
          },
          onAfterEdit: () => {
            // Do nothing.
          },
          onEdit: () => {
            // Do nothing.
          }
        }
      }
    },
    watchDataForFilters () {
      return [this.getItemStatuses, this.$i18n.locale]
    }
  },

  watch: {
    watchDataForFilters: {
      immediate: true,
      deep: true,
      handler () {
        const defaultActive = ['draft', 'pending', 'final', 'new', 'completed']
        // AD30-1251 Only completed will be supported.
        const fhirStatusCodes = [
          { value: 'completed', label: 'Completed (fhir)' }
        ]
        const decorStatusCodes = this.getItemStatuses || []
        this.filters = [...decorStatusCodes, ...fhirStatusCodes].map(status => {
          const currentlyActive = this.filters?.find(filter => filter.key === status.value)?.active
          return {
            name: this.$filters.getMatchingTranslation({ value: status.label, locale: this.$i18n.locale }),
            key: status.value,
            active: currentlyActive !== undefined
              ? currentlyActive
              : defaultActive.includes(status.value)
          }
        }) || []
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.component-questionnaires-panel {
  table {
    tr {
      td {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;

        &:not(.v-data-table__mobile-row) {
          max-width: 0;
        }
      }
    }
  }
}
</style>
